<template>
  <div class="mobile_partner">
    <TopInside theme_="light"  ></TopInside>

    <img
      class="mobile_inside"
      src="../../../static/mobile/brief_0.jpg"
      alt=""
    />
    <div class="mobile_list_con">
      <p class="mobile_partner_title">合作伙伴</p>
      <div class="mobile_list">
        <div v-for="(item, i) in list" :key="i" class="list_item"  @click="go(item.link)">
          <img :src="item.src" alt="" />
        </div>
        <p @click="checkMore()" class="more">{{checkTitle}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import TopInside from "./TopInside.vue";

export default {
  name: "",
  mixins: [],
  components: {
    TopInside,
  },
  props: {},
  data() {
    return {
      list: [],
      list_1: [
        {
          name: "内蒙产权交易市场",
          src: require("../../../static/parter/p-3.png"),
          link: "http://nmgcqjy.ejy365.com/",
        },
        {
          name: "内蒙住建",
          src: require("../../../static/parter/p-30.png"),
          link: "http://zjt.nmg.gov.cn/",
        },
        {
          name: "中国通用招标网",
          src: require("../../../static/parter/p-32.png"),
          link: "https://www.china-tender.com.cn/",
        },
        {
          name: "内蒙招标采购",
          src: require("../../../static/parter/p-31.png"),
          link: "https://imbpa.nmgztb.com.cn/",
        },
      ],
      list_2: [
        {
          name: "比德电子采购平台",
          src: require("../../../static/parter/p-8.png"),
          link: "https://www.bdebid.com/",
        },
        {
          name: "新疆和田公共资源交易中心",
          src: require("../../../static/parter/p-38.jpg"),
          link: "http://ggzy.xjht.gov.cn:8081/",
        },
        // {
        //   name: "e交易",
        //   src: require("../../../static/parter/p-2.png"),
        //   link: "https://www.ejy365.com/",
        // },

        // {
        //   name: "云采供",
        //   src: require("../../../static/parter/p-34.png"),
        //   link: "http://ycg.86ztb.com/index.htm",
        // },
		{
		  name: "中航发",
		  src: require("../../../static/parter/p-42.jpg"),
		  link: "https://ebidding.aecc-mall.com/cms/index.htm",
		},
		
		{
		  name: "华电",
		  src: require("../../../static/parter/p-41.png"),
		  link: "https://www.chdtp.com/",
		},
      ],
      list_3: [
        {
          name: "中国平安",
          src: require("../../../static/parter/p-9.jpg"),
          link: "https://www.pingan.com",
        },
        {
          name: "华商",
          src: require("../../../static/parter/p-25.jpg"),
          link: "https://www.cmbcn.com.cn/",
        },
        {
          name: "中国人民",
          src: require("../../../static/parter/p-19.jpg"),
          link: "https://www.picc.com/",
        },
        {
          name: "中国人寿",
          src: require("../../../static/parter/p-20.jpg"),
          link: "https://www.chinalife.com.cn/chinalife/index/",
        },
      ],
      list_4: [
        {
          name: "华泰",
          src: require("../../../static/parter/p-23.png"),
          link: "https://www.ehuatai.com/",
        },
        {
          name: "紫金保险",
          src: require("../../../static/parter/p-10.png"),
          link: "http://www.zking.com",
        },
        {
          name: "安华农业保险",
          src: require("../../../static/parter/p-12.png"),
          link: "http://www.ahic.com.cn/",
        },
        {
          name: "国任保险",
          src: require("../../../static/parter/p-15.png"),
          link: "https://www.guorenpcic.com/",
        },
      ],
      checkTitle:'查看更多'
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    
    this.list = [...this.list_1]
  },
  methods: {
    checkMore(){
      let len = this.list.length
      let arr = this.list
     switch(len){
      case 4:
        this.list = [...arr ,...this.list_2]
        break;
      case 8:
        this.list = [...arr ,...this.list_3]
        break;
      case 12:
        this.list = [...arr ,...this.list_4]
        this.checkTitle = '收起'
        break;
      case 16:
        this.list= this.list_1
        this.checkTitle = '查看更多'
        break;
     }
    },
    go(url) {
      window.open(url);
    },
  },
};
</script>

<style scoped >
.mobile_list_con{
  width: 100%;
  background: #fefefe;
  overflow-x: hidden;
  color: #5F6464;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.mobile_partner_title {
  font-size: 1.25rem;
  font-style: italic;
  color: #2a2e2e;
  width: 100%;
  text-align: center;
  margin: 3rem 0;
}
.mobile_list{
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.list_item{
  width:19.31rem ;
  height: 6.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  border-radius: 1px;
  gap: 1rem;

}
.list_item img{
  width: 70%;
}
.more{
  width: 100%;
  text-align: center;
  font-size:1rem ;
  color: rgb(26, 112, 231);
  margin: 1rem 0;
}
.mobile_inside {
  width: 100%;
}
</style>
